export default {
  workspaceAiIsEnabled(state) {
    return state.workspaceAiIsEnabled;
  },
};
